import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const MagazineBlock = ({ articles }) => {
  const { t } = useLang();
  if (!articles || !Array.isArray(articles) || articles.length === 0) return null;
  const [lead, ...rest] = articles;
  const side = (rest || []).slice(0, 3);

  return (
    <section className="px-6 md:px-16 my-12 md:my-16 lg:my-20" data-testid="magazine-block">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Link to={`/revista/${lead.slug}`} data-testid={`magazine-lead-${lead.id}`} className="group block relative overflow-hidden rounded-sm">
          <div className="aspect-[16/9] bg-zinc-900">
            {lead.cover_url ? <img src={lead.cover_url} alt={lead.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full bg-zinc-800" />}
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <p className="text-[11px] tracking-[0.2em] uppercase text-[#E11D48] mb-2">{lead.category}</p>
            <h3 className="font-heading text-2xl md:text-3xl leading-tight group-hover:text-white">{lead.title}</h3>
            <p className="text-sm text-zinc-300 mt-2 line-clamp-2 max-w-xl">{lead.excerpt}</p>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-white/10 border border-white/10 rounded-sm">
          {side.map((a) => (
            <Link key={a.id} to={`/revista/${a.slug}`} data-testid={`magazine-side-${a.id}`} className="group flex gap-4 p-4 hover:bg-white/[0.02] flex-1">
              <div className="w-28 h-20 shrink-0 bg-zinc-900 overflow-hidden rounded-sm">
                {a.cover_url ? <img src={a.cover_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" /> : <div className="w-full h-full bg-zinc-800" />}
              </div>
              <div className="min-w-0">
                <p className="text-[10px] tracking-[0.2em] uppercase text-[#E11D48]">{a.category}</p>
                <h4 className="font-medium leading-snug mt-1 line-clamp-2 group-hover:text-[#E11D48] transition-colors">{a.title}</h4>
                <p className="text-xs text-zinc-500 mt-1">{t("byAuthor")} {a.author_name}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export const MagazineRow = ({ articles }) => {
  const { t } = useLang();
  if (!articles || articles.length < 4) return null;
  return (
    <section className="px-6 md:px-16 my-12 md:my-16 lg:my-20" data-testid="magazine-row">
      <div className="flex items-baseline justify-between mb-4 border-b border-white/10 pb-2">
        <h2 className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight text-white">
          ARTÍCULOS Y CRÍTICAS RECIENTES
        </h2>
        <Link to="/revista" className="text-xs font-semibold text-zinc-400 hover:text-[#E11D48] transition-colors uppercase">
          {t("allArticles")} →
        </Link>
      </div>
      <div className="flex gap-5 overflow-x-auto no-scrollbar pb-2">
        {articles.map((a) => (
          <Link key={a.id} to={`/revista/${a.slug}`} data-testid={`magazine-row-${a.id}`} className="group flex-shrink-0 w-64">
            <div className="aspect-[16/10] bg-zinc-900 overflow-hidden rounded-sm">
              {a.cover_url ? <img src={a.cover_url} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" /> : <div className="w-full h-full bg-zinc-800" />}
            </div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-[#E11D48] mt-3">{a.category}</p>
            <h4 className="font-medium leading-snug mt-1 line-clamp-2 group-hover:text-[#E11D48] transition-colors">{a.title}</h4>
          </Link>
        ))}
      </div>
    </section>
  );
};
